import JobCandidateResumeContainer from './job_candidate_resume_container';

const JobCandidateResume = JobCandidateResumeContainer;
export default JobCandidateResume;
